// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__SWH-U","inputWrap":"styles_inputWrap__1YcGC","input":"styles_input__twjhk"};